/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function (Flickity) {
  // Add custom code below this line

  var elem = document.querySelector('.cart__widget__products');
  var flkty = new Flickity(elem, {
    pageDots: false,
    cellAlign: 'left',
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})(themeVendor.Flickity);

document.addEventListener('DOMContentLoaded', function() {
  const tabButtons = document.querySelectorAll('.product-tabs-tab-wrapper .tab-link');
  const tabContents = document.querySelectorAll('.product-tabs-content-wrapper');

  if (tabButtons.length > 0) {
    tabButtons[0].classList.add('active');
  }

  if (tabContents.length > 0) {
    tabContents[0].classList.add('active');
  }

  if (tabButtons && tabContents) {
    tabButtons.forEach((tabBtn) => {
      tabBtn.addEventListener('click', () => {
        const tabId = tabBtn.getAttribute('data-name');

        tabButtons.forEach((btn) => btn.classList.remove('active'));
        tabBtn.classList.add('active');
        tabBtn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });

        tabContents.forEach((content) => {
          content.classList.remove('active');
          const contentId = content.getAttribute('data-name');

          if (contentId === tabId) {
            content.classList.add('active');
          }
        });
      });
    });
  }
});

//cookie consent bar
class CookieConsentBar extends HTMLElement {
  constructor() {
    super();
    this.cookieBarWrapper = this.closest(".shopify-section");
    this.acceptButton = this.querySelector("#cookie-consent-bar-button");
    this.cookieName = "nlbeauty-cookie-consent";
    this.cookieExpiresDays = 30;
  }

  connectedCallback() {
    this.onLoad();
    this.acceptButton.addEventListener("click", this.acceptCookie.bind(this));
  }

  disconnectedCallback() {
    this.acceptButton.removeEventListener("click", this.acceptCookie);
  }

  onLoad() {
    let isCookieAccepted = this.getCookie(this.cookieName);
    if (typeof isCookieAccepted != "undefined" && isCookieAccepted) {
    } else {
      this.cookieBarWrapper.classList.remove("hidden");
    }
  }

  getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  acceptCookie() {
    const d = new Date();
    d.setTime(d.getTime() + this.cookieExpiresDays * 24 * 60 * 60 * 1000);

    document.cookie = this.cookieName + "=1;expires=" + d.toUTCString();
    this.cookieBarWrapper.classList.add("hidden");
  }
}

if (!window.customElements.get("cookie-consent-bar")) {
  window.customElements.define("cookie-consent-bar", CookieConsentBar);
}
//end cookie consent bar

function updateSaveBadge(variant) {
  const productSaveBadges = document.querySelectorAll('.product__price .upsell-save-badge');
  const productFreeDeliveryBadge = document.querySelector('.product-badge-free-delivery');

  productSaveBadges.forEach(badge => {
    if (variant && variant.compare_at_price > variant.price) {
      badge.classList.remove('hide');
      let productSaveBadgeDiscount = badge.querySelector('.upsell-discount-percentage');
      let productSaveAmount = ((variant.compare_at_price - variant.price));

      const moneyFormat = window.theme?.moneyFormat || '${{amount}}';
      const amount = parseFloat((productSaveAmount / 100).toFixed(2));

      let formattedSaveAmount = moneyFormat.replace(/\{\{\s*[\w_]+\s*\}\}/g, amount);

      productSaveBadgeDiscount.textContent = formattedSaveAmount;
    }
    else if (variant && variant.compare_at_price < variant.price || variant.compare_at_price == variant.price ){
      badge.classList.add('hide');
    }
  });

  if (productFreeDeliveryBadge && variant) {
    let productFreeDeliveryThreshold = parseInt(productFreeDeliveryBadge.dataset.shippingLimit)*100;

    if (variant.price >= productFreeDeliveryThreshold) {
      productFreeDeliveryBadge.classList.remove('hide');
    } else {
      productFreeDeliveryBadge.classList.add('hide');
    }
  }
}

function updateAllVariantSaveBadges() {
  document.querySelectorAll('.upsell-save-badge').forEach(badge => {
    const discountElement = badge.querySelector('.upsell-discount-percentage');
    if (discountElement && discountElement.textContent) {
      const numericValue = discountElement.textContent.replace(/[^\d.,]/g, '');
      if (numericValue) {
        const currencySymbol = window.Shopify?.currency?.symbol?.active;
        discountElement.textContent = `${currencySymbol}${numericValue}`;
      }
    }
  });
}

document.addEventListener('theme:variant:change', function(e) {
  const variant = e.detail.variant;
  updateSaveBadge(variant);
});
